import React from 'react'
import { Collapse,  } from '@bedrock/components'
import classNames from "classnames/bind";
import styles from "./index.less";

const cx = classNames.bind(styles)

// 对齐 Collapse.Panel 的参数类型
type CollapseTablePanelProps = React.ComponentProps<typeof Collapse.Panel>
const CollapseTablePanel =function(props: CollapseTablePanelProps){
    const {className, headerClass, header, children, ...restProps} = props
    return (
        <Collapse.Panel
            className={cx('collapse-table-wrapper', className)}
            headerClass={cx('header', headerClass)}
            destroyInactivePanel={false}
            header={<div
                className={cx('table-wrapper-header')}
            >
                {header}
            </div>}
            {...restProps}
        >
            {children}
        </Collapse.Panel>
    )
}

export default CollapseTablePanel;
